<template>
  <header class="header">
    <router-link to="/" class="logo">Horizon Protocol</router-link>
    <button class="login-btn" @click="handleLogin">Войти</button>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  emits: ['login'],
  setup(props, { emit }) {
    const handleLogin = () => {
      alert('Функция входа будет реализована в полной версии');
      emit('login');
    };

    return {
      handleLogin
    };
  }
};
</script>